import { LOCAL_STORAGE_PREFIX } from 'constants/global';

export function getWindowVar(name) {
  return window[`${LOCAL_STORAGE_PREFIX}${name}`] || null;
}
